import { render } from "./SportEntityDetails.vue?vue&type=template&id=3ae51c4a&scoped=true"
import script from "./SportEntityDetails.vue?vue&type=script&lang=js"
export * from "./SportEntityDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/UltimaMonitor_lgames/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae51c4a"]])

export default __exports__